export const virtualizedScrollbarProps = {
  store: Object,
  alwaysOn: Boolean,
  className: String,
  layout: {
    type: String,
    default: 'vertical',
  },
  total: {
    type: Number,
    required: true,
  },
  ratio: {
    type: Number,
    required: true,
  },
  clientSize: {
    type: Number,
    required: true,
  },
  scrollbarSize: {
    type: Number,
    default: 6,
  },
  startGap: { type: Number, default: 0 },
  endGap: { type: Number, default: 2 },
  visible: {
    type: Boolean,
    default: true
  },
  scroll: Object,
  scrollbarPosition: String,
  scrollFrom: Number,
  scrollbarStyle: Object,
  offset: Number
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/props/scroll-bar.js